<template>
  <component :is="tag" data-module="CmsColumnJson">
    <slot :json="json" v-if="!loading"></slot>
  </component>
</template>

<script>
import {getColumns} from "~/api/CmsApi";
import SystemColumnId from "../../enum/SystemColumnId";

/**
 * 获取栏目信息，根据父ID获取父ID下的所有子栏目，返回结果是个json对象
 * 此组件适用于页面最高层级标签，通过当前页面的栏目ID，获取到页面在的所有子栏目，并且直接通过栏目key获取栏目信息
 */
export default {
  name: 'CmsColumnJson',
  props: {
    /**
     * 栏目父ID
     */
    pid: {
      type: [String, Number],
      // 默认获取中文版栏目下子栏目
      default: '1'
    },
    /**
     * 分页查询起始页
     */
    page: {
      type: Number,
      default: 1
    },
    /**
     * 分页大小
     */
    limit: {
      type: Number,
      default: 999
    },
    /**
     * 指定元素渲染出的标签
     */
    tag: {
      type: String,
      default: 'div'
    }
  },
  data() {
    return {
      loading: true,
      json: {}
    };
  },
  watch: {
    pid: {
      handler(value) {
        if (value) {
          this.initialize();
        }
      },
      immediate: true
    }
  },
  methods: {
    /**
     * 初始化数据
     */
    initialize() {
      const param = { page: this.page, limit: this.limit, pid: this.pid };
      this.json = {};
      getColumns(param).then(res => {
        if (res.code === 0) {
          const resList = res.data.records || [];
          const json = {};
          resList.forEach(item => {
            const key = this.getJsonKey(item);
            if (key) {
              json[key] = item;
            }
          });
          this.json = json;
          this.$emit('loaded', json);
        } else {
          console.warn('栏目信息获取失败');
        }
        this.loading = false;
      })
    },
    getJsonKey(item) {
      for (const key in SystemColumnId) {
        const column2st = SystemColumnId[key];
        for (const key2st in column2st) {
          if (column2st[key2st] === item.id) {
            return key2st;
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cms/CmsColumnJson.vue